import { gql } from '@apollo/client';
import { pascalCase } from 'change-case';
import { AggregateDefinition, getAggregateDataFields } from '@terragotech/gen5-shared-components';

// eslint-disable-next-line import/no-anonymous-default-export
export default (aggregateDefinition: AggregateDefinition) => gql`query assetsQuery($filters: ${pascalCase(
  aggregateDefinition.name
)}${aggregateDefinition.view ? 'sView' : ''}Filter, $first: Int, $after: Cursor, $orderBy: [${pascalCase(
  aggregateDefinition.queryKey
)}${aggregateDefinition.view ? 'Views' : ''}OrderBy!] , $last: Int, $before: Cursor, $conditions: ${pascalCase(
  aggregateDefinition.name
)}${aggregateDefinition.view ? 'sView' : ''}Condition){
    ${aggregateDefinition.queryKey}: ${aggregateDefinition.queryKey}${
  aggregateDefinition.view ? 'Views' : ''
}Connection(filter: $filters, first: $first, after: $after, orderBy: $orderBy, last: $last, before: $before, condition: $conditions) {
      edges {
        node{
          ${getAggregateDataFields(
            aggregateDefinition,
            undefined,
            undefined,
            undefined,
            true,
            !!aggregateDefinition.view
          )}
          id
          label
          symbolKey
          primaryLocation {
            geojson
          }
        }
        cursor
      }
      pageInfo{
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }`;

export const FilterQuery = (
  aggregateDefinition: AggregateDefinition,
  aggregateDefinitions: AggregateDefinition[],
  field: string,
  fieldType: string,
  limitValue?: number,
  offsetValue?: number,
  searchValue?: string
) => {
  const tableName = aggregateDefinition.queryKey;
  const fieldDef = aggregateDefinition.propertyDefinitions.find(def => def.field === field);
  const limit = limitValue ?? null;
  const offset = offsetValue ?? null;
  const searchText = searchValue ? searchValue : '';
  if (fieldDef?.isRelationship) {
    const relatedDef = aggregateDefinitions.find(a => a.name === fieldDef.type);
    return gql`query MyQuery($selectedProjects: [String!]!){
          distinctValues(
            filter: {tableName: "${tableName}${aggregateDefinition.view ? 'View' : ''}", columnName: "tb.label"}
            join: {tableName: "${relatedDef?.queryKey}", columnName: "id", parentColumnName: "${field}"}
            project: {columnName: "project", values: $selectedProjects}
            limit: ${limit}
            offset: ${offset}
            searchText: "${searchText}"
            fieldType: "${fieldType}"
            ${aggregateDefinition.view ? 'schema: "views"' : ''}
          )
        }`;
  } else {
    return gql`query MyQuery ($selectedProjects: [String!]!) {
          distinctValues(
            filter: {tableName: "${tableName}${aggregateDefinition.view ? 'View' : ''}", columnName: "${field}"}
            project: {columnName: "project", values: $selectedProjects}
            limit: ${limit}
            offset: ${offset}
            searchText: "${searchText}"
            fieldType: "${fieldType}"
            ${aggregateDefinition.view ? 'schema: "views"' : ''}
          )
        }`;
  }
};

export const RecordTypeAssetCountQuery = (aggregateDefinition: AggregateDefinition) => {
  return gql`query assetsQuery($filters: ${pascalCase(aggregateDefinition.name)}Filter){
        ${aggregateDefinition.queryKey}: ${aggregateDefinition.queryKey}Connection(filter: $filters) {
         totalCount
      }}`;
};

export const UnavailableDataQuery = (startTime: number, endTime: number, limit: number) => {
  return gql`query MyQuery{
        unavailableIds (startTime:${startTime},endTime:${endTime},limit:${limit}) {
          id
          type
        }
      }`;
};

export const createAssetQueryWithFilter = (
  aggregateDefinition: AggregateDefinition,
  selectedProjects: string[],
  searchText: string
) => {
  const projectList = JSON.stringify(selectedProjects);
  return `
        ${aggregateDefinition.queryKey}Connection(
          filter: { or:  {${aggregateDefinition.labelProperty}: {
            includesInsensitive: "${searchText}"}},
            ${aggregateDefinition.isReferenceType ? '' : `projectId: { in: ${projectList}}`}
          },
          first: 20,
        ) {
          edges {
            node{
              ${getAggregateDataFields(aggregateDefinition)}
              id
              label
              symbolKey
              primaryLocation {
                geojson
              }
            }
          }
          totalCount
        }
      `;
};

export const GlobalSearchQueryCreator = (
  aggregateDefinitions: AggregateDefinition[],
  selectedProjects: string[],
  searchText: string
) => {
  const queryParts = aggregateDefinitions
    .map(def => createAssetQueryWithFilter(def, selectedProjects, searchText))
    .join('\n');
  const queryString = `query MyQuery {
    ${queryParts}
  }`;
  return gql`
    ${queryString}
  `;
};
